<template>
  <div
    v-if="reviewsData?.paging.totalResults && fitRating?.display_values"
    class="b b-grey-50 p-4 space-y-2 b-0 o:p-0"
  >
    <p id="size-fit-rating" class="text-xs ">
      {{ $t.fitBasedOn }}
      <base-link
        class="underlined"
        :to="{
          hash: '#reviews',
          query,
          state,
        }"
        @click="$gtm.push('pdpPage.onViewReviews')"
      >
        {{
          replaceAll(
            $pluralize($t.numberOfReviews, reviewsData?.rollup?.reviewCount!),
            { reviewsCount: reviewsData?.rollup?.reviewCount },
          )
        }}
      </base-link>
    </p>
    <vf-meter
      aria-labelledby="size-fit-rating"
      :aria-valuetext="getFitRatingValues(fitRating).label"
      :max-label="fitRating.display_values[fitRating.display_values.length - 1]"
      :max-value="fitRating.display_values.length"
      :min-label="fitRating.display_values[0]"
      :value="getFitRatingValues(fitRating).value"
    />
  </div>
</template>

<script lang="ts" setup>
const { fitRating, reviewsData } = usePdp()
const { query } = useRoute()
const { state } = useRouter().options.history
</script>
